const processOrderProductsWithZone = (headers, orderItems, payload, transData, restOrder, type = 0) => {
  let getHeaders = ''
  let getContent = ''
  for (let i = 0; i < headers.length; i++) {
    if (headers[i].value === 'qty' || headers[i].value === 'price' || headers[i].value === 'discount' || headers[i].value === 'total') getHeaders += `<th class="th-fontsize text-right" width="${headers[i].width}">${headers[i].text}</th>`
    else getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
  }
  Object.keys(orderItems).forEach((key) => {
    getContent += `<tr><td></td><td colspan="3">${key === 'null' ? '' : `Sone.${key}`}</td>
      <td class="th-fontsize text-right">${key === 'null' ? '' : calculateTotal(orderItems[key])}</td></tr>`
    for (let j = 0; j < orderItems[key].length; j++) {
      const invoiceItems = orderItems[key][j]
      getContent += '<tr class="comments_border_remove">'
      for (let i = 0; i < headers.length; i++) {
        if (key !== 'null' && (headers[i].value === 'price' || headers[i].value === 'discount' || headers[i].value === 'total')) continue
        if (headers[i].value === 'producttext') {
          getContent += `<td class="th-fontsize">
            ${invoiceItems[headers[i].value] || ''}
          </td>`
        } else if (headers[i].value === 'qty' || headers[i].value === 'price' || headers[i].value === 'discount' || headers[i].value === 'total') getContent += `<td class="th-fontsize text-right">${invoiceItems[headers[i].value] || ''}</td>`
        else getContent += `<td class="th-fontsize">${invoiceItems[headers[i].value] || ''}</td>`
        if ((headers.length - 1) === i && invoiceItems['comments']) {
          getContent += `<tr class="comments_border_remove"><td></td><td colspan="3">${invoiceItems['comments'] || ''}</td></tr>`
        }
        if ((headers.length - 1) === i && type === 4 && invoiceItems['product_hs']) {
          getContent += `<tr class="comments_border_remove"><td></td><td colspan="3">HS: ${invoiceItems['product_hs'] || ''}</td></tr>`
        }
        if ((headers.length - 1) === i && invoiceItems['deliverydate'] && type !== 4) {
          getContent += `<tr class="comments_border_remove"><td></td><td colspan="3">${transData.delivery}: ${invoiceItems['deliverydate'] || ''}</td></tr>`
        }
      }
      getContent += '</tr>'
    }
  })
  return content(getHeaders, getContent, payload, transData, restOrder)
}

const calculateTotal = (zone) => {
  let total = 0
  zone.map(x => {
    total += +x.totalFormat
    return x
  })
  if (total === null || total === undefined || total === '') return ''
  return getRoundedNumberWithPrecision(total).toFixed(2).toString().replace('.', ',')
}

const getRoundedNumberWithPrecision = (num, decimalPlaces = 2) => {
  var p = Math.pow(10, decimalPlaces)
  var n = (num * p) * (1 + Number.EPSILON)
  return Math.round(n) / p
}

const content = (headers, content, payload, transData, restOrder) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
    .comments_border_remove td {
      border-top: none !important;
    }
    .commentslist { page-break-before: always; }
    tbody tr { page-break-inside:avoid; }
    tbody tr td { word-break: break-word; }
    body {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
      letter-spacing: 0.3px;
      font-size: 16px !important;
    }
    .table-content {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    }
    .table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {
      padding: 2.5px !important;
    }
    .header-font-size {
      font-size: 16px;
    }
    </style>
  </head>
  <body>
  <div class="container-fluid">
    <div class="row">
    <div class="col-xs-12">
    <table style="width: 100%;">
      <tr>
        <td width="45%" rowspan=2 class="header-font-size" style="vertical-align:top">
          <div>
            <span>${payload.customername || ''}</span><br>
            <span>${payload.customeraddress_address || ''}</span><br>
            ${payload.customeraddress_address2 ? `<span>${payload.customeraddress_address2 || ''}</span><br>` : ''}
            <span>${payload.customeraddress_postcode || ''} ${payload.customeraddress_city || ''}</span><br>
          </div>
        </td>
        <td width="30%">
          <div>
            <span>Kilab AS, 912195759</span><br>
            <span>Majorvegen 22, 2030 Nannestad</span><br>
            <span>firmapost@kilab.no &nbsp; &nbsp; www.kilab.no</span><br><br>
          </div>
        </td>
        <td width="25%" style="vertical-align:top">
          <img class="img-responsive pull-right" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
        </td>
      </tr>
      <tr>
        <td colspan=2>
          <div class="row">
            <div class="col-xs-6 col-xs-offset-1 text-left">
              <h4 style="font-size:18px;margin-left: 0px;padding-left: 0px;margin-right: 0px;padding-left: 0px;">${restOrder ? `${transData.restorder} ${restOrder}` : ''}</h4>
            </div>
            <div class="col-xs-5 text-right">
            <h4 style="font-size:18px"><b>${transData.confirm}</b></h4>
            </div>
          </div>
        </td>
      </tr>
    </table>

  </div>
  <div class="col-xs-7 header-font-size">
    <div class="row">
      <div class="col-xs-6" style="margin-right: 0px;margin-top: 10px;">
        <span><b>${transData.deliveryAddress}</b></span><br>
        <span>${payload.customername || ''}</span>
        <div>
          <span>${payload.deliveryaddress_address || ''}</span><br>
          ${payload.deliveryaddress_address2 ? `<span>${payload.deliveryaddress_address2 || ''}</span><br>` : ''}
          <span>${payload.deliveryaddress_postcode || ''} ${payload.deliveryaddress_city || ''}</span>
        </div>
      </div>
      <div class="col-xs-6" style="margin-right: 0px;margin-top: 10px;">
        <span style="margin-top: 10px;"><b>${transData.invoiceAddress}</b></span><br>
        <span>${payload.invoicetoname || ''}</span>
        <div>
          <span>${payload.invoiceto_address || ''}</span><br>
          ${payload.invoiceto_address2 ? `<span>${payload.invoiceto_address2 || ''}</span><br>` : ''}
          <span>${payload.invoiceto_postcode || ''} ${payload.invoiceto_city || ''}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xs-5 header-font-size" style="margin-left: 0px; padding-left: 0px;">
    <hr style="margin: 1px;" />
    <table style="width: 100%">
      <tr>
        <td width="50%">${transData.number}:</td>
        <td width="50%" class="text-right">${payload.number || ''}</td>
      </tr>
      <tr>
        <td width="50%">${transData.customerNum}:</td>
        <td width="50%" class="text-right">${payload.customernumber || ''}</td>
      </tr>
    </table>
    <table style="width: 100%">
      <tr>
        <td width="30%">${transData.saleRef}:</td>
        <td width="70%" class="text-right">${payload.salesreference || ''}</td>
      </tr>
    </table>
    <table style="width: 100%">
      <tr>
        <td width="45%">${transData.ourreference}:</td>
        <td width="55%" class="text-right">${payload.ourreferencename || ''}</td>
      </tr>
      <tr>
        <td>${transData.yourreference}:</td>
        <td class="text-right">${payload.yourreference || ''}</td>
      </tr>
      ${payload.type === 'order' ? `<tr>
          <td>${transData.yourOrderNumber}:</td>
          <td class="text-right">${payload.yourordernumber || ''}</td>
        </tr>` : ''}
      <tr>
        <td>${transData.contact}:</td>
        <td class="text-right">${payload.contactname || ''}</td>
      </tr>
      <tr>
        <td>${transData.labeled}:</td>
        <td class="text-right">${payload.labeled || ''}</td>
      </tr>
      ${payload.type === 'offer' ? `<tr>
          <td>${transData.offerdate}:</td>
          <td class="text-right">${payload.offerdate || ''}</td>
        </tr>` : ''}
      ${payload.type === 'offer' ? `<tr>
        <td>${transData.offerdue}:</td>
        <td class="text-right">${payload.offerduedate ? `${payload.offerduedate} ${transData.days}` : ''}</td>
      </tr>` : `<tr>
        <td>${transData.orderdate}</td>
        <td class="text-right">${payload.orderdate || ''}</td>
      </tr>`}
    </table>
    <table style="width: 100%">
      <tr>
        <td width="50%">${transData.shipment}:</td>
        <td width="50%" class="text-right">${payload.shipmentname || ''}</td>
      </tr>
      <tr>
        <td>${transData.paymentTerm}:</td>
        <td class="text-right">${payload.paymentterms ? `${payload.paymentterms} ${transData.days}` : `${payload.customerpaymentterm} ${transData.days}`}</td>
      </tr>
      <tr>
        <td>${transData.deliveryTime}:</td>
        <td class="text-right">${payload.deliverytime || ''}</td>
      </tr>
    </table>
  </div>
      <div class="col-xs-12 table-content">
        <table class="table table-condensed" style="width: 100%">
          <tbody>
            <tr>
              ${headers}
            </tr>
            ${content}
          </tbody>
        </table>
      </div>
    <div class="col-xs-6"></div>
    <div class="col-xs-6 table-content">
      <table style="width: 75%" class="pull-right">
        <tr>
          <th colspan="2">
            <hr style="margin: 4px" />
          </th>
        </tr>
        <tr>
          <th width="70%">${transData.totalExVat}:</th>
          <td width="30%" class="text-right">${payload.totalexvat || ''}</td>
        </tr>
        <tr>
          <th width="70%">${transData.totalVAT}:</th>
          <td width="30%" class="text-right">${payload.totalvat || ''}</td>
        </tr>
        <tr>
          <th width="70%">${transData.total} (${payload.currencyname ? payload.currencyname : 'NOK'}):</th>
          <td width="30%" class="text-right">${payload.totalsum || ''}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="commentslist">
    ${payload.standardsales || ''}
    </div>
    <div class="commentslist">
      ${payload.standarddeliveryterms || ''}
    </div>
</body>
</html>`)))
export default processOrderProductsWithZone
